import React, { useState } from "react";

import { PageContent } from "../../components";
import { useGetOutboundOrders } from "../../hooks";
import { OutboundOrdersTable } from "../../tables";
import { useScannerHelper } from "../../helpers";
import { OutboundServiceOrderDialog } from "../../dialogs";

const purchaseOrderRegex = /^V[A-Z]{2}-\d{6}$/;

export const OutboundOrders = ({ defaultLocation = 1 }) => {
  const [poNumber, setPoNumber] = useState(false);
  const { isLoading } = useGetOutboundOrders({ defaultLocation });

  const setPurchaseOrder = (barcode) => {
    const validPo = purchaseOrderRegex.test(barcode);
    if (validPo) setPoNumber(barcode);
  };

  useScannerHelper(setPurchaseOrder);

  return (
    <PageContent isLoading={isLoading}>
      <OutboundOrdersTable
        defaultLocation={defaultLocation}
        setPoNumber={setPoNumber}
      />
      <OutboundServiceOrderDialog
        poNumber={poNumber}
        onClose={() => setPoNumber(false)}
      />
    </PageContent>
  );
};

export default OutboundOrders;
